import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  AddProductComponentFormHandle,
  AddProductComponentFormProps,
  Component
} from './AddProductComponentForm';
import * as yup from 'yup';
import axiosInstance from 'utils/axiosInterceptors';
import { toast } from 'react-toastify';
import { toastConfig } from 'utils/toastConfig';
import { AxiosError } from 'axios';
import { Col, Form, Row } from 'react-bootstrap';

const EditProductComponent = forwardRef<
  AddProductComponentFormHandle,
  AddProductComponentFormProps
>(({ productId, componentId, quantity, unitOfMeasure }, ref) => {
  const [component, setComponent] = useState({
    quantity: quantity,
    unitOfMeasure: unitOfMeasure
  });
  console.log(productId, componentId, quantity, unitOfMeasure);

  const handleFormChange = <K extends keyof Component>(
    field: K,
    value: Component[K]
  ) => {
    setComponent(prev => ({ ...prev, [field]: value }));
  };

  const componentSchema = yup.object().shape({
    quantity: yup.number().required().min(1, 'Quantity must be at least 1')
  });

  const handleSubmit = async () => {
    try {
      await componentSchema.validate(component, { abortEarly: false });
      await axiosInstance.put(
        `/api/v1/productSets/${productId}/components/${componentId}`,
        {
          quantity: component.quantity,
          unitOfMeasure: component.unitOfMeasure
        }
      );
      toast.success('Product added to the product set', {
        ...toastConfig,
        autoClose: 2000
      });
      return true;
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        error.inner.forEach(err => {
          toast.error(err.message, { ...toastConfig, autoClose: 3000 });
        });
      } else if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
      return false;
    }
  };

  useImperativeHandle(ref, () => ({
    submit: handleSubmit
  }));

  return (
    <>
      <Form>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Quantity</Form.Label>
            <Form.Control
              type="number"
              value={component.quantity}
              onChange={e => handleFormChange('quantity', +e.target.value)}
            />
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Unit Of Measure</Form.Label>
            <Form.Control
              value={component.unitOfMeasure}
              as="select"
              onChange={e => handleFormChange('unitOfMeasure', e.target.value)}
            >
              <option value="Piece">Piece</option>
              <option value="Set">Set</option>
              <option value="Meter">Meter</option>
              <option value="Foot">Foot</option>
            </Form.Control>
          </Form.Group>
        </Row>
      </Form>
    </>
  );
});

export default EditProductComponent;
